const FORD_BRAND = "F";
const LINCOLN_BRAND = "L";

const BRANDS = {
  F: "Ford Brand",
  L: "Lincoln Brand",
};

export { BRANDS, FORD_BRAND, LINCOLN_BRAND };
